export const LoadingWhiteSpinner = "/Assets/loading.gif";
export const PinkQoutesIcon = "/Assets/qoutesIcon.svg";
export const NewEndQoutes = "/Assets/newEndQoutes.svg";
export const NewStartQoute = "/Assets/newStartQoute.svg";
export const PinkArabicQoutesIcon = "/Assets/arabicQoutes.svg";
export const LeftArrow = "/Assets/leftArrow.svg";
export const RightArrow = "/Assets/rightArrow.svg";
export const NewLeftArrow = "/Assets/newLeftArrow.svg";
export const NewRightArrow = "/Assets/newRightArrow.svg";
export const RightIcon = "/Assets/rightIcon.svg";
export const WhatsAppIcon = "/Assets/whatsApp.svg";
export const ClipboardIcon = "/Assets/Clipboard.svg";
export const WhatsAppSmallIcon = "/Assets/whatsappSmallIcon.svg";
export const PinkBoxIcon = "/pinkBox.png";
export const WearThatLogo = "/Assets/WearThatLogo.svg";
export const WTGIF = "/Assets/wt.gif";
export const MenuIcon = "/Assets/hamburgerMenu.svg";
export const NewMenuIcon = "/Assets/sideDrawericon.svg";
export const CloseIcon = "/Assets/closeIcon.svg";
export const CrossIconBox = "/Assets/CrossIconBox.svg";
export const Home = "/Assets/home.svg";
export const infoIcon = "/Assets/infoIcon.svg";
export const InfoIcon2 = "/Assets/info_Icon.svg";
export const Aboutus = "/Assets/aboutus.svg";
export const GiftCard = "/Assets/giftCard.svg";
export const VideoIcon = "/Assets/VideoIcon.svg";
export const RightArrowIcon = "/Assets/RightArrow.svg";
export const ReferFriend = "/Assets/referFriend.svg";
export const AmbassadorIcon = "/Assets/ambassadorIcon.svg";
export const ReadApproved = "/Assets/ReadApproved.png";
export const InStudioStylingSession = "/Assets/inStudioStylingSession.svg";
export const CalendarIcon = "/Assets/calendar_icon.svg";
export const SuccessTick = "/Assets/successTick.svg";
export const SuccessTickPink = "/Assets/successTickPink.svg";
export const FailedIcon = "/Assets/failedIcon.svg";
export const ClockIcon = "/Assets/clockIcon.svg";
export const LanguageIcon = "/Assets/languageIcon.svg";
export const NewLanguageIcon = "/Assets/newLanguageIcon.svg";
export const NewNotificationIcon = "/Assets/NotificationIcon.svg";
export const CancelIcon = "/Assets/cancelIcon.svg";
export const Line = "/Assets/Line.svg";
export const PlusIcon = "/Assets/plusIcon.svg";
export const BinIcon = "/Assets/bin.svg";
export const PinIcon = "/Assets/pin.svg";
export const LeftQoutes = "/Assets/leftQoutes.svg";
export const RightQoutes = "/Assets/rightQoutes.svg";
export const ArabicStart = "/Assets/arabicStart.svg";
export const ArabicEnd = "/Assets/arabicEnd.svg";
export const ShopTheLookIcon = "/Assets/ShopTheLook.svg";
export const UpArrow = "/Assets/upArrow.svg";
export const DownArrow = "/Assets/downArrow.svg";
export const PlayButton = "/Assets/PlayButton.svg";
export const SearchIcon = "/Assets/Search.svg";
export const TrendingIcon = "/Assets/Trending.svg";
export const BigBellIcon = "/Assets/bigBell.svg";
export const TwitterIcon = "/Assets/twitter.svg";
export const InstagramIcon = "/Assets/instagram.svg";
export const FacebookIcon = "/Assets/facebook.svg";
export const PinterestIcon = "/Assets/pinterest.svg";
export const BlogsIcon = "/Assets/BlogsIcon.svg";
export const WTLogoEnglish = "/Assets/WTLogoEnglish.svg";
export const WTLogoEnglishWhite = "/Assets/WTLogoEnglishWhite.svg";
export const WTLogoArabic = "/Assets/WTLogoArabic.svg";
export const OrderABox = "/Assets/orderABox.svg";
export const QRCode = "/Assets/qr-code.svg";
export const OrderInQueue = "/Assets/orderInQueue.svg";
// export const AccountSettings = "/Assets/accountSettings.svg";
export const DashboardFAQs = "/Assets/DashboardFAQs.svg";
// export const Logout = "/Assets/Logout.svg";
export const MyBoxes = "/Assets/myBoxes.svg";
export const ReferralActivities = "/Assets/ReferralProgramHowItWorksIcons.svg";
export const YourPreferences = "/Assets/yourPreferences.svg";
export const Right = "/Assets/Right.svg";
export const RightPink = "/Assets/RightPink.svg";
export const BreadcrumbRightArrow = "/Assets/BreadcrumbRightArrow.svg";
export const ProfileSetupIcon = "/Assets/ProfileSetup.svg";
export const AddressDetailsIcon = "/Assets/addressDetails.svg";
export const ChangePasswordIcon = "/Assets/changePassword.svg";
export const PaymentDetailsIcon = "/Assets/paymentDetails.svg";
export const MastercardIcon = "/Assets/MasterCardIcon.svg";
export const VisaIcon = "/Assets/VisaCardIcon.svg";
export const AddIconCircle = "/Assets/AddIconCircle.svg";
export const VisaSmallIcon = "/Assets/VisaIcon.svg";
export const MasterSmallIcon = "/Assets/MasterIcon.svg";
export const DiscoverCardIcon = "/Assets/DiscoverIcon.svg";
export const DinersCardIcon = "/Assets/DinersInternationalIcon.svg";
export const AmericanExpressIcon = "/Assets/AmericanExpressIcon.svg";
export const JCBCardIcon = "/Assets/JCBIcon.svg";
export const DropdownArrowDown = "/Assets/ArrowDropdown.svg";
export const DropdownArrowUp = "/Assets/PinkUpArrow.svg";
export const Mute = "/Assets/Mute.svg";
export const Unmute = "/Assets/Unmute.svg";
export const MuteIcon = "/Assets/muteIcon.svg";
export const UnmuteIcon = "/Assets/unmuteIcon.svg";
export const playIcon = "/Assets/playIcon.svg";
export const pauseIcon = "/Assets/pauseIcon.svg";
export const HomeBannerPlaceHolder = "/Assets/HomeBannerPlaceHolder.webp";
export const CheckIcon = "/Assets/check.svg";
export const HolidayIcon = "/Assets/holiday.svg";
export const GoingOutIcon = "/Assets/goingOut.svg";
export const WorkIcon = "/Assets/work.svg";
export const EssentialsIcon = "/Assets/essentials.svg";
export const ProgressBall = "/Assets/ProgressDot.svg";
export const ProgressBallBlack = "/Assets/ProgressDotBlack.svg";
export const ProgressBallDarkGrey = "/Assets/ProgressDotDarkGrey.svg";
export const BoxScheduled = "/Assets/BoxScheduled.svg";
export const WT_Logo = "/Assets/Logo.png";
export const ConfirmationIcon = "/Assets/confirmationIcon.svg";
export const PreviousButtonSvg = "/Assets/PreviousButton.svg";
export const NextButtonSvg = "/Assets/NextButton.svg";
export const SampleImage = "/Assets/sampleImage.png";
export const CircleError = "/Assets/CircleError.svg";
export const TertiaryRightArrow = "/Assets/arrowRight.svg";
export const BlackSimpleArrow = "/Assets/RightBlackArrow.svg";
export const WearthatLoading = "/Assets/WearthatLoading.gif";
export const WearthatLoadingMOV = "/Assets/loader.MOV";
export const BlackHamburgerMenu = "/Assets/BlackHamburgerMenu.svg";
export const WhiteHamburgerMenu = "/Assets/WhiteHamburgerMenu.svg";
export const SerenaLogo = "/Assets/SerenaLogo.svg";
export const WhiteRightArrow = "/Assets/whiteRightArrow.svg";
export const BlackPlusIcon = "/Assets/blackPlusIcon.svg";
export const MinusIcon = "/Assets/minusIcon.svg";
export const Switch_404 = "/Assets/404-switch.png";
export const cartMinus = "/Assets/cartMinus.svg";
export const cartPlus = "/Assets/cartPlus.svg";
export const cartDemoImg = "/Assets/cartDemoImg.png";
export const StepOne = "/Assets/step1.svg";
export const StepTwo = "/Assets/step2.svg";
export const EditIcon = "/Assets/Edit-Icon.svg";
export const Cart = "/Assets/Cart.svg";
export const CartSmall = "/Assets/CartSmall.svg";
export const NewCartWhite = "/Assets/NewCartWhite.svg";
export const BlackCross = "/Assets/BlackCross.svg";
export const SmallPlus = "/Assets/Plus14x14.svg";
export const SmallMinus = "/Assets/Minus14x14.svg";
export const promoSuccessIcon = "/Assets/promoSuccess.svg";
export const BlackBin = "/Assets/BlackBin.svg";
export const ArrowLeft = "/Assets/arrowLeft.svg";
export const MobileSizeChart = "/Assets/mobileSizeChart.svg";
export const SizeChart = "/Assets/sizeChart.svg";
export const TickInCircleGreen = "/Assets/TickInCircleGreen.svg";
export const CrossInCircleRed = "/Assets/CrossInCircleRed.svg";
export const WishListWhiteIcon = "/Assets/wishlist_white_24x24";
export const WishListBlackIcon = "/Assets/wishlist_black_24x24.svg";
export const EcommCart = "/Assets/cart_white_24x24.svg";
export const WhiteChevronDown = "/Assets/white_chevron_down.svg";
export const FilterIcon = "/Assets/Filter.svg";
export const FunnelIcon = "/Assets/Funnel.svg";
export const SearchIconWhite = "/Assets/SearchIconWhite.svg";
export const BlackCross_24x24 = "/Assets/BlackCross_24x24.svg";
export const ArrowDownPlaneEnds = "/Assets/arrowDownPlaneEnds.svg";
export const AccountAvatar = "/Assets/AccountAvatar.svg";
export const ShoppingBag = "/Assets/Shoppingbag.svg";
export const ShoppableSection = "/Assets/ShoppableSessions.svg";
export const ThumbsDownFocusedIcon = "/Assets/thumbsDownFocusedIcon.svg";
export const ThumbsDownIcon = "/Assets/thumbsDownIcon.svg";
export const ThumbsUpIcon = "/Assets/thumbsUpIcon.svg";
export const ThumbsUpFocusedIcon = "/Assets/thumbsUpFocusedIcon.svg";
export const DressStyleIcon = "/Assets/dressStyleIcon.svg";
export const ContectStepIcon = "/Assets/contectStepIcon.svg";
export const EmailVerification = "/Assets/emailVerification.svg";
export const VideoCameraIcon = "/Assets/videoCameraIcon.svg";
export const SaudiIcon = "/Assets/Saudi.svg";
export const UAEIcon = "/Assets/UAE.svg";
export const ReferralProgramStep1Icon = "/Assets/ReferralProgramStep1Icon.svg";
export const ReferralProgramStep2Icon = "/Assets/ReferralProgramStep2Icon.svg";
export const ReferralProgramStep3Icon = "/Assets/ReferralProgramStep3Icon.svg";
export const BigOrderABox = "/Assets/bigOrderABox.svg";
export const BigMyBoxes = "/Assets/bigMyBoxes.svg";
export const BigPreferences = "/Assets/bigPreferences.svg";
export const BigSettings = "/Assets/bigSettings.svg";
export const BigFAQs = "/Assets/bigFAQs.svg";
export const BigRewards = "/Assets/bigRewards.svg";
export const GoogleIcon = "/Assets/googleIcon.svg";
export const AppleIcon = "/Assets/apple-icon.svg";
export const ApplePymentIcon = "/Assets/ApplePymentIcon.svg";
export const InviteFriend = "/Assets/InviteFriend.webp";
export const JoinOurAmbassadors = "/Assets/JoinOurAmbassadors.webp";
export const ExploreNow = "/Assets/ExploreNow.webp";
export const StyledBoxes = "/Assets/StyledBoxes.webp";
export const StyleMyWardrobe = "/Assets/StyleMyWardrobe.webp";
export const ShoppableSessions = "/Assets/ShoppableSessions.webp";
export const Security = "/Assets/Security.svg";
export const TabbyLogo = "/Assets/tabby-logo.png";
export const Stopper = "/Assets/stopper.svg";
export const SearchIconGrey = "/Assets/SearchIconGrey.svg";
export const SmallMenuUserIcon = "/Assets/SmallMenuUserIcon.svg";
export const ApplePayLogo = "/Assets/applePayLogo.svg";
export const HidePassword = "/Assets/Hidepassword.svg";
export const ShowPassword = "/Assets/Showpassword.svg";
export const ShippingQuestionMark = "/Assets/shippingQuestionMark.svg";
export const PromoCodeTag = "/Assets/promoCodeTag.svg";
export const CheckoutCards = "/Assets/checkoutCards.svg";

//new header account menu icons
export const AccountSettings = "/Assets/AccountDropDown/AccountSettings.svg";
export const Credits = "/Assets/AccountDropDown/Credits.svg";
export const FAQs = "/Assets/AccountDropDown/FAQs.svg";
export const Logout = "/Assets/AccountDropDown/Logout.svg";
export const MyDashboard = "/Assets/AccountDropDown/MyDashboard.svg";
export const MyOrders = "/Assets/AccountDropDown/MyOrders.svg";
export const MyStylePreference =
    "/Assets/AccountDropDown/MyStylePreference.svg";
export const Referrals = "/Assets/AccountDropDown/Referrals.svg";
export const Wishlist = "/Assets/AccountDropDown/Wishlist.svg";

// Eoy Wrap Images

export const rightCornerStars = "/Assets/right-corner-stars.svg";
export const leftCornerStars = "/Assets/left-corner-stars.svg";
export const oneItemFrame = "/Assets/OneItemFrame.png";

//----------------------------Ecom Assets-----------------------------

export const ShippingIcon = "/Assets/shipping.svg";
export const ReturnsIcon = "/Assets/returns.svg";
export const TrackingIcon = "/Assets/tracking.svg";
export const LockIcon = "/Assets/lock.svg";
export const EcommCartBlack = "/Assets/black_cart_24x24.svg";
export const CreativeEditCard = "/Assets/CreativeEditCard.webp";
export const AllEditsCard = "/Assets/AllEditsCard.webp";
export const EntrepreneurialEditCard = "/Assets/EntrepreneurialEditCard.webp";
export const BellIconBlack = "/Assets/BellIconBlack.svg";
export const OldMoneyBannerDesktop = "/Assets/OldMoneyBannerDesktop.webp";
export const SerenaBySeaHeroImage = "/Assets/SerenaBySeaHeroImage.webp";
export const FilledHeart = "/Assets/Filled-Heart.svg";
export const EmptyHeart = "/Assets/Empty-Heart.svg";
export const DesktopBanner =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630393/HomePageAssets/mhkvpmeqdwzpfbki8v5r.webp";
export const MobileBanner =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630390/HomePageAssets/zlslyh0mipxgpsbfamri.webp";
export const QuickAddToCartIcon =
    "/Assets/circular_black_icon_with_white_plus_sign_24x24.svg";
export const BlackChevronDown = "/Assets/BlackChevronDown.svg";
export const ChevronDown = "/Assets/chevron-down.svg";
export const WhiteArrow = "/Assets/whiteArrow.svg";
export const CorporateEditCard = "/Assets/corporate_edit_card.webp";
export const EducationEditCard = "/Assets/EducationEditCard.webp";
export const EventPRManagementEditCard =
    "/Assets/EventPRManagementEditCard.webp";
export const WearthatXTamaraWhite = "/Assets/WearThatTamaraFarra.svg";
export const WearthatXTamaraBlack = "/Assets/WearThatTamaraFarraBlack.svg";

// Sale banner
export const SaleBannerDesktop = "/Assets/sale/new-sale-banner-desktop.jpg";
export const SaleBannerMobile = "/Assets/sale/sale-banner-mobile-new.jpg";

export const BasmaCategoryHeroBannerDesktop =
    "/Assets/CategoryHeroPictures/BasmaCategoryHeroBannerDesktop.webp";
export const JessieHeroBannerDesktop =
    "/Assets/CategoryHeroPictures/JessieHeroBannerDesktop.webp";
export const JessieHeroBannerMobile =
    "/Assets/CategoryHeroPictures/JessieHeroBannerMobile.webp";
export const SerenaByTheSeaCategoryHeroBannerDesktop =
    "/Assets/CategoryHeroPictures/SerenaByTheSeaCategoryHeroBannerDesktop.webp";
export const SerenaCategoryHeroBannerDesktop =
    "/Assets/CategoryHeroPictures/SerenaCategoryHeroBannerDesktop.webp";
export const SerenaCategoryHeroBannerMobile =
    "/Assets/CategoryHeroPictures/SerenaCategoryHeroBannerMobile.webp";
export const TamaraSmoothSailingCategoryHeroBannerDesktop =
    "/Assets/CategoryHeroPictures/TamaraSmoothSailingCategoryHeroBannerDesktop.webp";

// The Party Edit
export const PartyEditPLPDesktop = "/Assets/PartyEditPLPDesktop.webp";
export const PartyEditPLPMobile = "/Assets/PartyEditPLPMobile.webp";

// Muzi Assets
export const MuziDesktopBanner = "/Assets/muzi/desktop-banner.jpg";
export const MuziMobileBanner = "/Assets/muzi/mobile-banner.jpg";
export const MuziLogo = "/Assets/muzi/logo.png";
export const UrbanMuse = "/Assets/muzi/urban-muse.png";
export const MuziInfoBanner = "/Assets/muzi/info-banner.jpg";
export const HeroDesktopBannerMuzi = "/Assets/muzi/banner-desktop.jpg";
export const HeroMobileBannerMuzi = "/Assets/muzi/banner-mobile.jpg";
export const MuziProduct1 = "/Assets/muzi/discover-collection/1.jpg";
export const MuziProduct2 = "/Assets/muzi/discover-collection/2.jpg";
export const MuziProduct3 = "/Assets/muzi/discover-collection/3.jpg";
export const MuziProduct4 = "/Assets/muzi/discover-collection/4.jpg";

// Serena Owns The Work
export const SerenaOwnsTheWorkDesktop =
    "/Assets/serena-owns-the-work/hero-section-desktop.jpg";
export const SerenaOwnsTheWorkMobile =
    "/Assets/serena-owns-the-work/hero-section-mobile.jpg";
export const croppedImage = "/Assets/serena-owns-the-work/cr.jpg";
export const ProductUnavailable = "/Assets/productUnavailable.svg";
export const NewCrossIcon = "/Assets/newCross.svg";
export const CostPerWearIcon = "/Assets/costPerWear.svg";

// Serena Sparkles
export const SerenaSparklesDesktop =
    "/Assets/SerenaSparkles/SerenaSparklesNavigationDesktop.webp";
export const SerenaSparklesMobile =
    "/Assets/SerenaSparkles/SerenaSparklesNavigationMobile.webp";
export const SparklseBannerDesktop =
    "/Assets/SerenaSparkles/SparklesHeroBannerDesktop.webp";
export const SparklseBannerMobile =
    "/Assets/SerenaSparkles/SparklesHeroBannerMobile.webp";
export const SparklesPLPDesktop =
    "/Assets/SerenaSparkles/SparklesBannerImage.webp";
export const SparklesPLPMobile =
    "/Assets/SerenaSparkles/SparklesBannerImageMobile.webp";
export const SerenaSparklesLogo =
    "/Assets/SerenaSparkles/SerenaSparklesLogo.png";
export const SparklesProduct1 = "/Assets/SerenaSparkles/Product1Sparkles.webp";
export const SparklesProduct2 = "/Assets/SerenaSparkles/Product2Sparkles.webp";
export const SparklesProduct3 = "/Assets/SerenaSparkles/Product3Sparkles.webp";
export const SparklesProduct4 = "/Assets/SerenaSparkles/Product4Sparkles.webp";

//Serena Fall Collection Assets
export const CamilleBomber = "/Assets/SerenaFallLaunch/CamilleBomber.webp";
export const LeaPleatedSkirt = "/Assets/SerenaFallLaunch/LeaPleatedSkirt.webp";
export const SophieBlazer = "/Assets/SerenaFallLaunch/SophieBlazer.webp";
export const MathildeFittedVest =
    "/Assets/SerenaFallLaunch/MathildeFittedVest.webp";
export const AmelieAsymmetricalTop =
    "/Assets/SerenaFallLaunch/AmelieAsymmetricalTop.webp";
export const ChloeSleevelessTurtleNeck =
    "/Assets/SerenaFallLaunch/ChloeSleevelessTurtleNeck.webp";
export const ClemenceCapriTrouser =
    "/Assets/SerenaFallLaunch/ClemenceCapriTrouser.webp";
export const EloieWhiteSkirt = "/Assets/SerenaFallLaunch/EloieWhiteSkirt.webp";
export const FallingForSerenaDesktop =
    "/Assets/SerenaFallLaunch/FallingForSerenaDesktop.webp";
export const FallingForSerenaMobile =
    "/Assets/SerenaFallLaunch/FallingForSerenaMobile.webp";
export const FallingForSerenaLogo =
    "/Assets/SerenaFallLaunch/FallingForSerenaLogo.svg";
export const FallEditBannerDesktop =
    "/Assets/SerenaFallLaunch/FallEditBannerDesktop.webp";
export const FallEditBannerMobile =
    "/Assets/SerenaFallLaunch/FallEditBannerMobile.webp";
export const TFELogo = "/Assets/SerenaFallLaunch/TFELogo.svg";
export const FrenchGirlBannerDesktop =
    "/Assets/SerenaFallLaunch/FrenchGirlBannerDesktop.webp";
export const FrenchGirlBannerMobile =
    "/Assets/SerenaFallLaunch/FrenchGirlBannerMobile.webp";
export const TFGELogo = "/Assets/SerenaFallLaunch/TFGELogo.svg";
export const FallingForSerenaCollectionDesktop =
    "/Assets/SerenaFallLaunch/FallingForSerenaCollectionDesktop.webp";

// Wear That x Kika Collection Assets
export const KikaCollectionDesktop =
    "/Assets/KikaXSerena/KikaCollectionsNavigationDesktop.webp";
export const KikaCollectionMobile =
    "/Assets/KikaXSerena/KikaCollectionsNavigationMobile.webp";
export const KikaMainBannerDesktop =
    "/Assets/KikaXSerena/KikaMainLandingPageHeroBannerDesktop.webp";
export const KikaMainBannerMobile =
    "/Assets/KikaXSerena/KikaMainLandingPageHeroBannerMobile.webp";
export const KikaPLPDesktop = "/Assets/KikaXSerena/KikaPLPDesktop.webp";
export const KikaPLPMobile = "/Assets/KikaXSerena/KikaPLPMobile.webp";
export const KikaCapsuleLogo = "/Assets/KikaXSerena/KikaCapsuleLogo.png";
export const KikaProduct1 = "/Assets/KikaXSerena/KikaProduct1.webp";
export const KikaProduct2 = "/Assets/KikaXSerena/KikaProduct2.webp";
export const KikaProduct3 = "/Assets/KikaXSerena/KikaProduct3.webp";
export const KikaProduct4 = "/Assets/KikaXSerena/KikaProduct4.webp";

//WorkEdits
export const CoverCorporateEditDesktop =
    "/Assets/WorkEdits/CoverCorporateEditDesktop.webp";
export const CoverCorporateEditMobile =
    "/Assets/WorkEdits/CoverCorporateEditMobile.webp";
export const CorporateEditFilter = "/Assets/WorkEdits/CorporateEditFilter.png";
export const CoverCreativeEditDesktop =
    "/Assets/WorkEdits/CoverCreativeEditDesktop.webp";
export const CoverCreativeEditMobile =
    "/Assets/WorkEdits/CoverCreativeEditMobile.webp";
export const CreativeEditFilter = "/Assets/WorkEdits/CreativeEditFilter.png";
export const CoverEducationEditDesktop =
    "/Assets/WorkEdits/CoverEducationEditDesktop.webp";
export const CoverEducationEditMobile =
    "/Assets/WorkEdits/CoverEducationEditMobile.webp";
export const EducationEditFilter = "/Assets/WorkEdits/EducationEditFilter.png";
export const CoverEntrepreneurialEditDesktop =
    "/Assets/WorkEdits/CoverEntrepreneurialEditDesktop.webp";
export const CoverEntrepreneurialEditMobile =
    "/Assets/WorkEdits/CoverEntrepreneurialEditMobile.webp";
export const EntrepreneurialEditFilter =
    "/Assets/WorkEdits/EntrepreneurialEditFilter.png";
export const CoverManagementEditDesktop =
    "/Assets/WorkEdits/CoverManagementEditDesktop.webp";
export const CoverManagementEditMobile =
    "/Assets/WorkEdits/CoverManagementEditMobile.webp";
export const ManagementEditFilter =
    "/Assets/WorkEdits/ManagementEditFilter.png";
export const CoverAllEditDesktop = "/Assets/WorkEdits/AllEditDesktop.webp";
export const CoverAllEditMobile = "/Assets/WorkEdits/AllEditMobile.webp";
export const AllEditFilter = "/Assets/WorkEdits/AllEditFilter.png";
export const NewJessieCollectionsImage =
    "/Assets/WorkEdits/WorkEditCollectionsImage.webp";

//Serena Ramadan Collection 2025
export const SerenaRamadanHeroBannerDesktop =
    "/Assets/serenaRamadan/home_hero_banner_serena_ramadan_desktop.webp";
export const SerenaRamadanHeroBannerMobile =
    "/Assets/serenaRamadan/home_hero_banner_serena_ramadan_mobile.webp";
export const SerenaRamadanNavigation =
    "/Assets/serenaRamadan/ramadan_collections_navigation_desktop.webp";
export const SerenaRamadanProduct1 =
    "/Assets/serenaRamadan/Ramadan_Product_1.webp";
export const SerenaRamadanProduct2 =
    "/Assets/serenaRamadan/Ramadan_Product_2.webp";
export const SerenaRamadanProduct3 =
    "/Assets/serenaRamadan/Ramadan_Product_3.webp";
export const SerenaRamadanProduct4 =
    "/Assets/serenaRamadan/Ramadan_Product_4.webp";
export const SerenaRamadanCollectionDesktop =
    "/Assets/serenaRamadan/capsule_ serena_ramadan_desktop.webp";
export const SerenaRamadanCollectionMobile =
    "/Assets/serenaRamadan/capsule_ serena_ramadan_mobile.webp";
export const SerenaRamadanPLPDesktop =
    "/Assets/serenaRamadan/serena_ramadan_PLP_hero_banner_desktop.webp";
export const SerenaRamadanPLPMobile =
    "/Assets/serenaRamadan/serena_ramadan_PLP_hero_banner_mobile.webp";

// soha collextion
export const SohaDesktopBanner = "/Assets/soha/soha_collection_desktop.webp";
export const SohaMobileBanner = "/Assets/soha/soha_collection_mobile.webp";
export const SohaCollectionDesktop =
    "/Assets/soha/soha_collections_navigation_desktop.webp";
export const SohaCollectionMobile =
    "/Assets/soha/soha_collections_navigation_mobile.webp";
export const SohaProduct1 = "/Assets/soha/soha_brown_dress.webp";
export const SohaProduct2 = "/Assets/soha/soha_blue_dress.webp";
export const SohaProduct3 = "/Assets/soha/soha_yellow_dress.webp";
export const SohaProduct4 = "/Assets/soha/soha_white_dress.webp";
export const SohaCapsuleCollectionDesktop =
    "/Assets/soha/soha_capsule_collection_desktop.webp";
export const SohaCapsuleCollectionMobile =
    "/Assets/soha/soha_capsule_collection_mobile.webp";
export const SohaHeroBannerDesktop =
    "/Assets/soha/soha_main_landing_hero_desktop.webp";
export const SohaHeroBannerMobile =
    "/Assets/soha/soha_main_landing_hero_mobile.webp";
// Register
export const signupRegister = "/Assets/signup.svg";
export const CheckCircle = "/Assets/checkItem.svg";

// Style Personality

export const effortLessVisionary =
    "/Assets/style_personality/effortless_visionary.svg";
export const freeSpirit = "/Assets/style_personality/free_spirit.svg";
export const gracefulDreamer = "/Assets/style_personality/graceful_dreamer.svg";
export const powerfulPresence =
    "/Assets/style_personality/powerful_presence.svg";

export const passwordEye = "/Assets/password-eye.svg";

export const PlusBlackIcon = "/Assets/plus-black-icon.svg";
export const BlackBinIcon = "/Assets/Black-Bin.svg";

export const brokenHeart = "/Assets/broken-heart.svg";
export const SurveyReminder = "/Assets/survey-reminder.svg";

export const PaymentSuccess = "/Assets/Payment-Successful.svg";
export const PaymentFailed = "/Assets/Payment-Failed.svg";

export const DislikeCheck = "/Assets/dislike_check.svg";

export const Eye = "/Assets/eye.svg";

export const NewCart = "/Assets/new-cart.svg";

export const GridLayout = "/Assets/grid-layout.svg";
export const SelectedGridLayout = "/Assets/grid-layout-selected.svg";

export const ListLayout = "/Assets/list-layout.svg";
export const SelectedListLayout = "/Assets/list-layout-selected.svg";
export const wearthatXBasma = "/Assets/wearthatXBasmaLogo.svg";

export const Filterclose = "/Assets/Filter-close.svg";

export const bellAlert = "/Assets/bell-alert.svg";
export const whatsappPinkBg = "/Assets/whatsappPinkBg.svg";
export const mailPinkBg = "/Assets/mailPinkBg.svg";
export const contactUsBanner = "/Assets/contactus.webp";

export const WearThatXMaramDesktop = "/Assets/maram/MaramBannerDesktop.png";
export const WearThatXMaramMobile = "/Assets/maram/MaramBannerMobile.png";

export const MaramProduct1 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630420/HomePageAssets/d90io5prqaghxsnvdodg.webp";
export const MaramProduct2 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630420/HomePageAssets/k0n5plhlfigwldtgbp9g.webp";
export const MaramProduct3 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630420/HomePageAssets/g4fjnevp9swajjvak1ub.webp";
export const MaramProduct4 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630420/HomePageAssets/tampe73lnk2pzgrw8weq.webp";

export const MaramHeroD1 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630393/HomePageAssets/mhkvpmeqdwzpfbki8v5r.webp";
export const MaramHeroD2 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630385/HomePageAssets/oaf0sfclufevwrreb0x8.webp";
export const MaramHeroD3 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630385/HomePageAssets/ndtwhhjgxycq5tgc6rdf.webp";
export const MaramHeroD4 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630386/HomePageAssets/uebw35qsxxbqyis4fq3t.webp";
export const MaramHeroM1 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630390/HomePageAssets/zlslyh0mipxgpsbfamri.webp";

export const HomeCarouselD1 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630389/HomePageAssets/yqt6tqoosi9enu8it26n.webp";
export const HomeCarouselD2 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630389/HomePageAssets/wzkun6detwnr8zuudpip.webp";
export const HomeCarouselD3 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630389/HomePageAssets/gyerq4j7htmmhdeakpuz.webp";
export const HomeCarouselD4 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630397/HomePageAssets/z2ps4qxlp33ixrclfe5m.webp";

export const HomeCarouselM1 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630383/HomePageAssets/cazumnthmitppethfkx5.webp";
export const HomeCarouselM2 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630389/HomePageAssets/rb6dtwh9iytqexi7jxau.webp";
export const HomeCarouselM3 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630387/HomePageAssets/cdwjkyeoikfc9seb7zjp.webp";
export const HomeCarouselM4 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630390/HomePageAssets/beak2vkjfl9afsvkgopr.webp";

export const MaramCapsule1 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630390/HomePageAssets/onvkjkgubvvdz197w1wx.webp";
export const MaramCapsule2 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630386/HomePageAssets/r6itxkec4v0zireljh1o.webp";
export const MaramCapsule3 =
    "https://res.cloudinary.com/wearthat/image/upload/v1747630388/HomePageAssets/v077or0wwxzx6hrtrf9z.webp";

export const EmptyCart = "/Assets/Empty-cart.svg";
export const GoogleMapsIcon = "/Assets/google_maps_icon.svg";

export const NewWearThatLoader = "/Assets/new-loader.gif";
